/* Dependencies */
import { ArticleProps } from './Article.model';

/**
 * Article
 * Used to apply overrides to Shopify's Article component markup.
 * @class
 */
export class Article {
  articleElement: HTMLElement;
  frameElements: HTMLIFrameElement[];

  constructor(props: ArticleProps) {
    this.articleElement = props.articleElement;

    this.defineElements();
  }

  /**
   * Define the requried elements.
   */
  defineElements(): void {
    this.frameElements = Array.from(
      this.articleElement.querySelectorAll('iframe')
    );

    // Wrap the embeds
    this.wrapVideoEmbeds();
  }

  /**
   * Wrap video embeds in a 16:9 container.
   */
  wrapVideoEmbeds(): void {
    const videoSrcs = ['vimeo', 'youtube'];

    // Loop through each iframe element and convert video iframes.
    this.frameElements.forEach((frameElement) => {
      // Look for the correct src.
      const containsSrc = videoSrcs.find((src) =>
        frameElement.src.includes(src)
      );

      // Ignore if the src is not a Youtube or Vimeo iframe.
      if (!containsSrc) return;

      // Clone the iframe to a new element;
      const newFrame = frameElement.cloneNode(true);

      // Create a container element & insert the new iframe.
      const containerElement = document.createElement('div');
      containerElement.classList.add('video-embed');
      containerElement.appendChild(newFrame);

      // Replace the original iframe with the container element.
      frameElement.insertAdjacentElement('afterend', containerElement);
      frameElement.parentNode.removeChild(frameElement);
    });
  }
}

/**
 * Initiates the article instance.
 */
export const articleInit = (): void => {
  const articleElements: HTMLElement[] = Array.from(
    document.querySelectorAll('[data-article]')
  );

  articleElements.forEach((articleElement) => {
    new Article({ articleElement: articleElement });
  });
};
